import { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Botao, Cartao } from '../../componentes/base';
import { Carregando, Erro } from '../../componentes/estados';
import { useToast } from '../../componentes/toast';
import { api, get, mensagemDeErro } from '../../nucleo/api';
import { podeNoWorkspace, useSessao } from '../../nucleo/sessao';

const OPCOES = [1, 2, 3, 6, 12, 24, 48, 72];
const MAXIMO = 5;

/** M6.6: com quantas horas de antecedência a agenda manda o lembrete pelo WhatsApp (padrão 24 h e 2 h). */
export function LembretesAgenda() {
  const { t } = useTranslation('agenda');
  const { t: tn } = useTranslation();
  const s = useSessao();
  const qc = useQueryClient();
  const toast = useToast();
  const pode = podeNoWorkspace(s, 'agenda.configurar');
  const q = useQuery({ queryKey: ['agenda', 'lembretes'], queryFn: () => get<{ horas_antes: number[] }>('/agenda/lembretes') });
  const [horas, setHoras] = useState<number[]>([]);
  useEffect(() => {
    if (q.data) setHoras(q.data.horas_antes);
  }, [q.data]);

  const salvar = useMutation({
    mutationFn: () => api<{ horas_antes: number[] }>('PUT', '/agenda/lembretes', { horas_antes: horas }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['agenda', 'lembretes'] });
      toast.sucesso(tn('comum.salvo'));
    },
    onError: (e) => toast.erro(mensagemDeErro(e)),
  });

  const opcoes = [...new Set([...OPCOES, ...(q.data?.horas_antes ?? [])])].sort((a, b) => a - b);
  const alterado = JSON.stringify([...horas].sort((a, b) => a - b)) !== JSON.stringify(q.data?.horas_antes ?? []);

  return (
    <Cartao
      titulo={t('lembretes.titulo')}
      acao={
        pode && (
          <Botao variante="secundario" tamanho="sm" disabled={!alterado} carregando={salvar.isPending} onClick={() => salvar.mutate()}>
            {tn('comum.salvar')}
          </Botao>
        )
      }
    >
      {q.isPending ? (
        <Carregando />
      ) : q.isError ? (
        <Erro erro={q.error} aoTentar={() => q.refetch()} />
      ) : (
        <fieldset>
          <legend className="mb-3 text-sm text-tinta-2">{horas.length ? t('lembretes.ajuda', { maximo: MAXIMO }) : t('lembretes.desligado')}</legend>
          <div className="flex flex-wrap gap-2">
            {opcoes.map((h) => {
              const marcado = horas.includes(h);
              return (
                <label key={h} className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-1.5 text-sm ${marcado ? 'border-acento-forte bg-acento-suave text-acento-forte' : 'border-borda text-tinta-2 hover:bg-sup-2'}`}>
                  <input
                    type="checkbox"
                    disabled={!pode || (!marcado && horas.length >= MAXIMO)}
                    checked={marcado}
                    onChange={(e) => setHoras((l) => (e.target.checked ? [...l, h] : l.filter((x) => x !== h)))}
                  />
                  <span className="numero">{t('lembretes.horas', { count: h })}</span>
                </label>
              );
            })}
          </div>
        </fieldset>
      )}
    </Cartao>
  );
}
